<template>
  <v-app id="inspire" style="height: 100vh">
    <v-row
      no-gutters
      class="pa-0 ma-0"
      :style="{ backgroundColor: $theme.options.toolbar.color ? '#ffffff' : '#1a1889', maxHeight: '70px' }"
    >
      <v-col class="d-flex px-5 align-center">
        <v-avatar
          max-height="40px"
          size="80"
          class="ml-3"
          tile
        >
          <ImagemComFallback
            :src="avatar"
            srcDefault="/assets/imgs/logo.svg"
            width="100%"
            height="100%"
            contain
          />
        </v-avatar>
      </v-col>
    </v-row>
    <v-main>
      <v-container
        fluid
        style="padding: 2%; height: calc(100vh - 70px);"
      >
        <v-row no-gutters style="height: 100%">
          <v-col cols="12" class="justify-center align-center">
            <v-card
              color="#FFFFFF"
              flat
              class="rounded-xl px-2"
              style="width: 100%; height: 90%; overflow: hidden;"
            >
              <div v-if="!success">
                <v-row>
                  <v-col cols="5" class="d-flex align-center justify-center">
                    <ImagemComFallback
                      :src="$theme.esqueceuSenha"
                      max-width="70%"
                      max-height="70%"
                      contain
                      srcDefault="/assets/imgs/esqueceu-senha.svg"
                    />
                  </v-col>
                  <v-col
                    cols="7"
                    class="pl-6 d-flex flex-column justify-center"
                  >
                    <div style="max-width: 550px" class="pl-9">
                      <core-form ref="form" :submit="recuperarSenha">

                        <v-row class="mb-9">
                          <span class="text-title"> Esqueceu a senha? </span>
                        </v-row>
                        <span>
                          Insira seu endereço de e-mail e enviaremos as instruções
                          para redefinição de senha.
                        </span>
                        <v-row class="pa-0 pt-4">
                          <v-col cols="8" class="pl-0">
                            <input-email
                              label="E-mail"
                              v-model="model.Usuario"
                              autofocus
                              outlined
                              required
                              hide-details
                            />
                          </v-col>
                        </v-row>
                        <v-row class="pl-0">
                          <v-col cols="8" class="pl-0">
                            <div class="d-flex justify-space-between">
                              <v-spacer></v-spacer>
                              <v-btn
                                color="primary"
                                elevation="0"
                                type="submit">
                                Enviar
                              </v-btn>
                            </div>
                          </v-col>
                        </v-row>
                      </core-form>
                    </div>
                  </v-col>
                </v-row>
              </div>
              <div v-else>
                <v-row>
                  <v-col cols="12">
                    <ImagemComFallback
                      srcDefault="/assets/imgs/esqueceu-senha-sucesso.svg"
                      :src="$theme.esqueceuSenhaSucesso"
                      max-height="450px"
                      max-width="100%"
                      contain
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-row class="justify-center">
                      <span class="text-title">E-mail enviado!</span>
                    </v-row>
                    <v-row class="justify-center pt-9">
                      <span class="text-body d-flex">
                        Não consegue encontra-lo? Verifique se há um e-mail de&nbsp;
                        <span class="underline underlineText--text text-font-16"
                          >bancodigital@moneyp.com.br</span>&nbsp;na sua caixa de spam ou clique em&nbsp;
                        <span class="underline underlineText--text text-font-16" @click="reenviarEmail"
                          >reenviar e-mail</span
                        >
                      </span>
                    </v-row>
                    <v-row class="justify-center pt-9 pb-5">
                      <v-btn color="primary" elevation="0" @click="redirectLogin">Ir para login</v-btn>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
export default {
  metaInfo: {
    title: 'Recuperação de Senha',
  },
  data () {
    return {
      model: {
        Usuario: '',
        Ambiente: this.$empresa.ambiente,
        CodigoPortal: this.$empresa.codigoPortal
      },
      success: false,
      avatar: this.$theme.logo
    };
  },
  methods: {
    recuperarSenha () {
      const th = this;
      th.$api.Autenticacao.EnviarEmailLinkSenhaOnboarding(th.model).then((response) => {
        if (th.$api.UI.PostLoadData(response, true)) {
          th.success = true;
        }
      })
    },
    reenviarEmail () {
      this.recuperarSenha();
    },
    redirectLogin () {
      this.$router.push('/partner/:parceiro')
    }
  },
};
</script>

<style scoped>
.text-title {
  color: var(--v-primary-base);
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.text-body {
  color: #3a3939;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
}
.underline {
  text-decoration-line: underline;
}
</style>
